export default {
  checkMonitoring: {},
  checkMonitorings: [],
}
